import {
    Component,
    Host,
    h,
    Prop,
    Fragment,
} from "@stencil/core";

@Component({
    tag: "c-form-table",
    styleUrl: "c-form-table.scss",
})
export class CFromTable {
    @Prop() tableType: string;

    buildTables = () => {
        const storage = localStorage.getItem(this.tableType);
        const mEntries = storage?.split("||");
        let multiEntries;
        if (this.tableType === "Education") {
            if (mEntries) {
                multiEntries = mEntries.map((entries) => {
                    const entry = entries.split(";");
                    return {
                        startDate: entry[1]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".")
                            .slice(3),
                        endDate: entry[2]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".")
                            .slice(3),
                        eduType: entry[0].split("=")[1],
                        eduName: entry[4].split("=")[1],
                        eduLocation: entry[3].split("=")[1],
                        eduMessage: entry[5].split("=")[1],
                    };
                });

                return (
                    <table id={this.tableType} class="rounded">
                        {multiEntries.map((entry) => {
                            return (
                                <Fragment>
                                    <tr>
                                        <td><b>
                                            {entry.startDate +
                                                " - " +
                                                entry.endDate}
                                        </b></td>
                                        <td><b>{entry.eduType}</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>{entry.eduName}</b></td>
                                        <td><b>{entry.eduLocation}</b></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>{entry.eduMessage}</td>
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </table>
                );
            }
        } else {
            if (mEntries) {
                multiEntries = mEntries.map((entries) => {
                    const entry = entries.split(";");
                    return {
                        language: entry[0].split("=")[1],
                        level: entry[1].split("=")[1],
                    };
                });
                return (
                    <table id={this.tableType} class="rounded">
                        {multiEntries.map((entry) => {
                            return (
                                <Fragment>
                                    <tr>
                                        <td><b>{entry.language}</b></td>
                                        <td><b>{entry.level}</b></td>
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </table>
                );
            }
        }
    };

    render() {
        return <Host class="">{this.buildTables()}</Host>;
    }
}